// export const baseURL = 'http://localhost:4002'
export const baseURL = 'https://api.ems.platinumeventset.com'

export const path = {
    login: '/login',
    tenant: '/superadmin/tenant',
    tenantUser: '/superadmin/tenant-user',
    dashboard: '/superadmin/dashboard',
    uploads: '/uploads/',
    uploadFile: '/upload-file',
}

export const access = {
    DASHBOARD: 'DASHBOARD',
    TENANTS: 'TENANTS',
    CREATE_TENANT: 'CREATE_TENANT',
    DELETE_TENANT: 'DELETE_TENANT',
    TENANT_USERS: 'TENANT_USERS',
    CREATE_TENANT_USERS: 'CREATE_TENANT_USERS',
    DELETE_TENANT_USERS: 'DELETE_TENANT_USERS'
}

export const TOKEN_KEY = 'ems_super_token'
export const MAIN_COLOR = '#004a59'